import { Text, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

export interface CardItemProps {
  label: string;
  value: string;
}

export const CardItem: React.FC<CardItemProps> = ({ label, value }) => {
  return (
    <VStack>
      <Text
        paddingBottom={Spacing['inline.quarck']}
        fontSize={Typography['fontsize.md']}
        fontWeight={Typography['fontweight.semibold']}>
        {label}
      </Text>
      <Text fontSize={Typography['fontsize.md']}>{value}</Text>
    </VStack>
  );
};
